import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number
}

const ProcessesAndDocumentsModuleBrand: FC<Props> = ({ size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white] = useToken('colors', [
    'primary.200',
    'primary.300',
    'primary.400',
    'primary.500',
    'primary.600',
    'primary.700',
    'primary.900',
    'white',
  ])

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth = '40px'
  const strokenWidth20 = '20px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <path
          fill={fillColor200}
          opacity="0.25"
          d="M185.18,251.53c-39.63,103.5-35,412.66,66.89,471C385.48,798.8,484.5,636.65,578.27,565,976.42,260.67,334.92-139.51,185.18,251.53Z"
          transform="translate(-46.34 -55)"
        />
        <g>
          <path
            fill={fillColor400}
            opacity="0.2"
            d="M217.36,642.42c4,39.05,28.69,74.66,67.79,90.25,52.22,20.83,112.63-2.48,138.12-53.31l.51-1A106.3,106.3,0,0,1,453.32,642a66.42,66.42,0,0,0,20.29-27.42c13.16-33-2.31-70.85-34.57-84.74-12.5-5.39-43.61-6.82-67.48-7.48-16.1-.45-28.24-4.75-36.85-18.4-9.79-15.51-39.83-29.32-62.45-22.54-42.42,12.73-47.6,24.21-68.26,63.95-9.27,17.83-27.71,36,2.36,60.93C214.51,613.07,216.27,631.81,217.36,642.42Z"
            transform="translate(-46.34 -55)"
          />
          <path
            fill={fillColor400}
            opacity="0.2"
            d="M308.54,322.54c10.07-36.16.23-77.66-29.63-107.31-39.9-39.61-102.67-43.51-143.52-8.91l-.81.7a95.82,95.82,0,0,1-39.44,20.14,59.5,59.5,0,0,0-27.95,16c-23.46,23.84-22.74,63.59,1.55,89,9.41,9.83,37,23.73,58.36,34,14.4,6.93,23.86,15.66,26.86,31.22,3.41,17.68,25.72,42.09,48.54,45.26,42.8,6,51.51-2.09,84.11-28.85,14.62-12,37.67-20.61,19.22-54.83C300.83,349.65,305.81,332.36,308.54,322.54Z"
            transform="translate(-46.34 -55)"
          />
          <path
            fill={fillColor400}
            opacity="0.2"
            d="M735.08,266.6c27.77-27.75,39.8-69.37,27.23-109.54-16.8-53.65-73-85.81-128.52-73.5l-1.11.25a106.49,106.49,0,0,1-46.83,0,66.46,66.46,0,0,0-34.08,1.57c-33.9,10.61-53.5,46.51-43.91,80.3,3.71,13.09,22.23,38.13,36.78,57.06,9.81,12.77,14.14,24.91,9,40.2-5.85,17.38,2.39,49.4,21.92,62.66,36.64,24.88,48.82,21.65,92.69,12.59,19.67-4.06,45.43-1.24,45.77-40.28C714.11,287.33,727.53,274.14,735.08,266.6Z"
            transform="translate(-46.34 -55)"
          />
        </g>
        <path
          fill={fillColor600}
          d="M187.72,589.05a32.81,32.81,0,0,0-37.22-13c-14.38,4.5-32.59,10.12-34.79,13.53-10.21,15.85,63.76,43.66,76.49,41C206.65,627.49,198.77,605.81,187.72,589.05Z"
          transform="translate(-46.34 -55)"
        />
        <path
          fill={fillColor600}
          d="M574.1,113.73c24.79,4.53,47.52-30,40.53-49.11-8.47-23.14-67.68.82-88.15,16C521.41,91,556.35,110,574.1,113.73Z"
          transform="translate(-46.34 -55)"
        />
        <path
          fill={fillColor600}
          d="M602.72,165.48C467.13,245.18,139,209,65.12,316.69-33.35,460.24,285,524.63,337,627,506.07,959.3,988.9-61.52,602.72,165.48Z"
          transform="translate(-46.34 -55)"
        />
        <path
          fill={fillColor600}
          d="M704.32,613.69c-82.29,81-52.51-9.83-45.73-26.66,9.37-23.28,4.87-27.91,21.76-34.52s57.64-5.59,58,12.55C739,594.68,723.21,595.09,704.32,613.69Z"
          transform="translate(-46.34 -55)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={fillBG}
          d="M613.4,260.28l-58.12-58.13a41.12,41.12,0,0,0-29.07-12H378.8a41.09,41.09,0,0,0-41.1,41.1V519a41.09,41.09,0,0,0,41.1,41.11H584.34A41.09,41.09,0,0,0,625.44,519V289.34A41.09,41.09,0,0,0,613.4,260.28Z"
          transform="translate(-46.34 -55)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth20}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M399.36,379.82H563.78"
          transform="translate(-46.34 -55)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth20}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M399.36,441.48H563.78"
          transform="translate(-46.34 -55)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth20}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M399.36,498.41H502.12"
          transform="translate(-46.34 -55)"
        />
        <path
          fill={fillBG}
          d="M399.36,298V267.16a15.38,15.38,0,0,1,15.39-15.39h30.87A15.39,15.39,0,0,1,461,267.16V298a15.39,15.39,0,0,1-15.4,15.4H414.75A15.39,15.39,0,0,1,399.36,298Z"
          transform="translate(-46.34 -55)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={fillBG}
          d="M523.34,320.32l-58.12-58.13a41.12,41.12,0,0,0-29.07-12H288.74a41.09,41.09,0,0,0-41.1,41.1V579a41.09,41.09,0,0,0,41.1,41.11H494.28A41.1,41.1,0,0,0,535.39,579V349.38A41.1,41.1,0,0,0,523.34,320.32Z"
          transform="translate(-46.34 -55)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth20}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M309.3,439.85H473.73"
          transform="translate(-46.34 -55)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth20}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M309.3,501.51H473.73"
          transform="translate(-46.34 -55)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth20}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M309.3,558.45H412.07"
          transform="translate(-46.34 -55)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth20}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={fillBG}
          d="M309.3,358.07V327.2a15.38,15.38,0,0,1,15.39-15.39h30.87A15.39,15.39,0,0,1,371,327.2v30.87a15.39,15.39,0,0,1-15.4,15.4H324.69A15.39,15.39,0,0,1,309.3,358.07Z"
          transform="translate(-46.34 -55)"
        />
      </svg>
    </Box>
  )
}

export default memo(ProcessesAndDocumentsModuleBrand)
